import React from 'react';
import classnames from 'classnames';
import './DifferenceTable.scss';

const DifferenceTable = props => {
  return (
    <>
      <table
        data-testid={props.datatestid}
        className={classnames('difference-table')}
      >
        {props.children}
      </table>
    </>
  );
};

DifferenceTable.Header = props => {
  return (
    <thead data-testid={props.datatestid} className={classnames()}>
      <tr>{props.children}</tr>
    </thead>
  );
};

DifferenceTable.HeaderCell = props => {
  return (
    <th
      data-testid={props.datatestid}
      className={classnames('text-16', 'fontGray400', 'bold', 'text-left')}
    >
      {props.children}
    </th>
  );
};

DifferenceTable.Body = props => {
  return <tbody data-testid={props.datatestid}>{props.children}</tbody>;
};
DifferenceTable.Row = props => {
  return <tr data-testid={props.datatestid}>{props.children}</tr>;
};

DifferenceTable.Cell = props => {
  return (
    <td data-testid={props.datatestid} className={props?.className}>
      {props.children}
    </td>
  );
};

DifferenceTable.CellHeader = props => {
  return (
    <div
      data-testid={props.datatestid}
      className={classnames('text-12', 'fontGray300')}
    >
      {props.children}
    </div>
  );
};

DifferenceTable.CellData = props => {
  return (
    <div
      data-testid={props.datatestid}
      className={classnames(
        { 'text-16': !props.fontClass, [props.fontClass]: !!props.fontClass },
        'fontGray400',
        'flex-container',
        'items-align-baseline',
        props.className,
      )}
    >
      {props.children}
    </div>
  );
};

export default DifferenceTable;
